import { Song } from '@repo/types'
import { CheckCircleIcon, CopyIcon } from '@repo/ui'
import { useSuccessButton } from '@repo/ui/client'
import { observer } from 'mobx-react-lite'

import { IconButton } from './IconButton'

export const createSystemPrompt = (song: Song) =>
  `
Please provide me with up to a dozen facts or some gossip (ideally 50% of each) about the song "${song.title}" by "${song.artist}". 
I'm a music bingo host and I want to keep my audience entertained when this song plays by dazzling them with my knowledge of such things in a playful manner. 
Please condense each item into a single row of text. Number each item, then provide the fact or detail (please keep each item under 120 characters) prioritized 
by most trustworthy result (how confident you are that it is true, rated as a %), and also identify it as either a FACT or GOSSIP (bolded, please).
`

export const AiCompanion = observer(({ song }: { song: Song }) => {
  const { showSuccess, showSuccessButtonState } = useSuccessButton()

  return (
    <IconButton
      icon={showSuccess ? <CheckCircleIcon /> : <CopyIcon />}
      title='AI Companion'
      tooltipProps={{
        placement: 'bottom',
        title: showSuccess ? 'Copied to clipboard' : 'Copy AI prompt for song facts'
      }}
      onClick={() => {
        navigator.clipboard.writeText(createSystemPrompt(song))
        showSuccessButtonState()
      }}
    />
  )
})
